const state = {
  name: '',
  userInfo: {},
  userId: '',
  roleId: '',
  roleName: '',
  lowerDivideCent: '',
  sessionId: ''
}
const mutations = {
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_USER: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ROLEID: (state, roleId) => {
    state.roleId = roleId
  },
  SET_LowerDivideCent: (state, lowerDivideCent) => {
    state.lowerDivideCent = lowerDivideCent
  },
  SET_SESSIONID: (state, sessionId) => {
    state.sessionId = sessionId
  },
  SET_ROLENAME: (state, roleName) => {
    state.roleName = roleName
  }
}

const actions = {
  // user logout
  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_USER', {})
      commit('SET_NAME', '')
      commit('SET_USERID', '')
      commit('SET_ROLEID', '')
      commit('SET_LowerDivideCent', '')
      commit('SET_SESSIONID', '')
      commit('SET_ROLENAME', '')
      localStorage.clear()
      resolve()
    })
  },

  setUserInfo ({ commit }, userInfo) {
    console.log(userInfo, '======================')
    commit('SET_USER', userInfo)
    commit('SET_NAME', userInfo.userName)
    commit('SET_USERID', userInfo.userId)
    commit('SET_ROLEID', userInfo.role.id)
    commit('SET_LowerDivideCent', userInfo.userEntity.fLowerDivideCent)
    commit('SET_SESSIONID', userInfo.userEntity.fSessionId)
    commit('SET_ROLENAME', userInfo.role.roleName)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
